import { schema } from "normalizr";

const attachment = new schema.Entity("attachments");
const arrayOfAttachments = [attachment];

export { attachment, arrayOfAttachments };
